export const pageTypes = [
	"start",
	"decision-input",
	"options-input",
	"pros-cons-input",
	"pros-cons-vote",
	"pros-cons-results",
	"weighted-vote-input",
	"weighted-vote-results",
	"randomiser",
	"final-results"
]